import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Store } from 'src/app/core/store/store';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { User } from 'src/app/shared/models/user.model';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends HandleSubscription implements OnInit {
  hidePartnerLogo = false;
  user: User;
  hideSidebar=false;
  accessRoute:Router;
  isDashboard= false;
  isThriveBot = false;
  constructor(private dashboardService: DashboardService,private router: Router,private store: Store,private activatedRoute:ActivatedRoute ) {
    super();
  }

  checkHabitdrillUrl() {
    const url = this.accessRoute.url.split('/');
    if (url.length > 0 && (url.includes('habit-drills')
      || url.includes('submission')
      || url.includes('feedback')
      || url.includes('notes-bookmarks')
      || url.includes('reports-certificate')
      || url.includes('leaderborad')
      || url.includes('profile'))) {
      return true;
    }
    return false;
  }

  checkDashboardURL(){
    if(this.router.url == '/dashboard'){
      return true
    }else{
      return false;
    }
  }

  ngOnInit(): void {
    this.accessRoute = this.router;
    this.hideSidebar = this.router.url.includes('benchmarking');
    this.isThriveBot = this.router.url.includes('ipj-bot');
    this.activatedRoute.url.subscribe(segments => {
      this.isThriveBot = this.router.url.includes('ipj-bot');
    });
    this.hidePartnerLogo = this.router.url.includes('auth/login');
    this.store.select<User>('user').pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
      if (user) {
        this.user = user;
        // this.findAllPrograms();
      }
    })
    this.findAllPrograms();
  }

  multipleProgramMenu= false;
  ipjPrograms =[];
  legacyPrograms =[];
  showHeaderDropdown = false;
  findAllPrograms(){
    let allPrograms = [];
    this.dashboardService.getActivePrograms().subscribe(res => {
      const activeProgram = JSON.parse(localStorage.getItem('activationInfo'));
      if(res){
        const progId= activeProgram?.['programActivationId'];
        this.multipleProgramMenu= true;
        if(res['data']['ipjmultiplePrograms'] && res['data']['ipjmultiplePrograms'].length>0 ){
          this.ipjPrograms= res['data']['ipjmultiplePrograms'];
          allPrograms.push(res['data']['ipjmultiplePrograms']);
        }
        if(res['data']['multiplePrograms'] && res['data']['multiplePrograms'].length>0){
          this.legacyPrograms= res['data']['multiplePrograms'];
          allPrograms.push(res['data']['multiplePrograms']);
        }

        if(allPrograms.length>1){
          this.showHeaderDropdown= true;
        }else if(allPrograms.length ==1){
          if(allPrograms[0].length>1){
            this.showHeaderDropdown=true
          }
        }
        this.ipjPrograms.forEach(element => {
          if(element.programActivationId == progId){
            element.isActive= true;
          }else{
            element.isActive=false;
          }

        })
        this.legacyPrograms.forEach(program => {
          if(program.Standalone){
            let link='/courses/'+program.title.toLowerCase().replaceAll(' ', '-')
            program.link=link
          }else{
            let link='/pathways/'+program.templateName.toLowerCase().replaceAll(' ', '-')
            program.link=link
          }
        })
      }
      this.store.set('IPJProgram', this.ipjPrograms)
      if(activeProgram) {
        this.getActivationInfo(activeProgram?.programActivationId, activeProgram?.programId)
      } else {
        this.getActivationInfo(this.ipjPrograms[0]?.programActivationId, this.ipjPrograms[0]?.programId)
      }
      this.store.set('legacyProgram', this.legacyPrograms)
    })
  }

  getActivationInfo(programActivationId, programId) {
    let opts = {
      programActivationId: programActivationId,
      programId: programId
    }
    this.dashboardService.getActivationInfo(opts).subscribe(res => {
      // this.activationInfo =  res.data

      localStorage.setItem('activationInfo', JSON.stringify({programActivationId: programActivationId, programId: programId, title: res.data.title, organization: res.data.organization}))
      this.store.set('activationInfo', res.data)
      
      this.getProgramActivation(programActivationId, programId)
      // this.getProgramActivation(programActivationId, programId);
    })
  }

  getProgramActivation(programActivationId, programId) {
    let activationInfo = JSON.parse(localStorage.getItem('activationInfo'))
    let opts = {
      "programActivationId": activationInfo.programActivationId,
      "programId": activationInfo.programId,
      "userGroup": this.user?.userGroup
    }
    this.dashboardService.getActivationDashboard(opts).subscribe(res => {
      // this.showLoaderDashboard = false;
      this.programData = res.data
      this.store.set('programData', this.programData)
      // window.location.reload()
    })
  }

  redirectToBusiness(link){
    let token = localStorage.getItem('token');
    if(token) {
      window.open(`${environment.businessDomain}${link}?accessToken=${token}`, '_blank');
    }
  }

  navigateToDashboard() {
    if(!this.user) {
      window.open(`${environment.mainDomain}?redirectSub=sd`, '_self');
      return;
    }
    if(this.router.url.includes('benchmarking')) {
      this.router.navigateByUrl(`/dashboard`, { state: { reload: false}});
    } else {
      this.router.navigate(['/dashboard'],{ state: { reload: true}});
    }
  }

  myFunction() {
    var x = document.getElementById("prog__nav");
    if (x.className === "prog__nav") {
        x.className += " responsive";
    } else {
        x.className = "prog__nav";
    }
}

loadNewIpjProgram(ipjProgram){
  let data = {
    "programActivationId":ipjProgram.programActivationId
  }
  this.dashboardService.updateProgramActivation(data).subscribe(res => {
    if(res){
      console.log('update activation response: ', res);
      //activation call
      this.getActivationInfo(ipjProgram.programActivationId, ipjProgram.programId)
      // this.getProgramActivation();
      // this.router.navigate(['/login']);
    }
  })

}
programData: any;
// getProgramActivation() {
//   let activeProgram=[];
//   this.dashboardService.getProgramActivation().subscribe(
//     (res: any) => {
//       res['data'].forEach(element => {
//         if(element.isActive){
//           activeProgram.push(element);
//         }
//       });
//       this.store.set('activation', this.programData);
//       this.router.navigate(['/login']);
//     }, (error) => {
//       console.log(error);
//     }
//   );
// }

}